module.exports = __webpack_public_path__ + "static/licensing-md-4c851c51d64f6097566c814bddede13f.jpg";